import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cgi",
  "use": "icon-cgi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cgi\"><path fill=\"#333333\" d=\"M28.672 710.656l353.28 227.328V771.072h609.28V649.216H381.952V482.304L28.672 710.656z m613.376-457.728H32.768v121.856h609.28v166.912l353.28-228.352L642.048 87.04v165.888z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol